import './App.css';
import { Routes, Route } from 'react-router-dom';
import Tasks from './Tasks/tasks';
import SecurityTasks from './Tasks/Securitytasks';
import Shop from './Shop/shop';
import X from './X/X';
import Tower from './X/Tower/Tower';
import T from './T/T';
import T2 from './T2/T2';
import T3 from './T3/T3';



function App() {
  return (
    <Routes>
      <Route index element={<Tasks/>}/>
      <Route path="/security" element={<SecurityTasks />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/X" element={<X/>}/>
      <Route path="/tower" element={<Tower/>}/>
      <Route path="/t" element={<T/>}/>
      <Route path="/t2" element={<T2/>}/>
      <Route path="/t3" element={<T3/>}/>
    </Routes>
  );
}

export default App;
